// extracted by mini-css-extract-plugin
export var editButton = "_n6-0";